import Vue from 'vue';
import Router from 'vue-router';
//import { store } from '../_store';

import HomePage         from '../home/HomePage'
import LoginPage        from '../login/LoginPage'
//import DetailPage       from '../views/DetailPage'
//import CategoriesPage   from '../views/Categories'
//import CategoryPage     from '../views/Category'
//import BioPage          from '../views/Bio'

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  routes: [
    { 
      path: '/', 
      component: () => import('../home/HomePage'),
      meta: { breadcrumb: 'Start' } },
    { 
      path: '/login', 
      name: 'LoginPage',
      component: () => import('../login/LoginPage')
    },




    {
      path: '/kategorien/:q',
      name: 'CategoriesPage',
      component: () => import('../views/CategoriesPage')
    },
    {
      path: '/kategorie/bio',
      name: 'BioPage',
      component: () => import('../views/BioPage')
    },
    {
      path: '/kategorie/:c/:s',
      name: 'CategoryPage',
      component: () => import('../views/CategoryPage')
    },
    { 
      path: '/detail/:pg/:artnr', 
      name:'DetailPage', 
      component: () => import('../views/DetailPage')
    },



    {
      path: '/basket',
      name: 'BasketPage',
      component: () => import('../views/BasketPage')
    },
    {
      path: '/checkout',
      name: 'CheckoutPage',
      component: () => import('../views/CheckoutPage')
    },
    {
      path: '/thankyou',
      name: 'ThankyouPage',
      component: () => import('../views/ThankyouPage')
    },


    {
      path: '/user',
      name: 'UserPage',
      component: () => import('../views/UserPage')
    },

    {
      path: '/user/orders/:i',
      name: 'OrderPage',
      component: () => import('../views/OrderPage')
    },


    {
      path: '/favorites',
      name: 'FavoritesPage',
      component: () => import('../views/FavoritesPage')
    },


    // otherwise redirect to home
    { path: '*', redirect: '/' }
  ]
});


/*
async beforeEnter(to, from, next) {
  try {
    var hasPermission = await store.dispatch("auth/hasPermission");
    if (hasPermission) {
      next()
    }
  } catch (e) {
    next({
      name: "login", // back to safety route //
      query: { redirectFrom: to.fullPath }
    })
  }
}
*/


router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  

  const loggedIn = localStorage.getItem('user');
    //store.dispatch('authentication/checkAuth');

  //console.log(loggedIn)
  if (authRequired && !loggedIn && 1==2 ) {  //&& 
    
    //store.dispatch('authentication/checkAuth');
    return next('/login');
  }

  next();
})